// Moves [data-mj-parallax="<speed>"] elements against the scroll for a depth effect.
// Off for reduced-motion users; only visible elements are updated.
(() => {
  if (window.mjParallax) return;
  window.mjParallax = true;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const visible = new Set();
  let ticking = false;

  const update = () => {
    ticking = false;
    const viewport = window.innerHeight;
    visible.forEach((el) => {
      const rect = el.parentElement.getBoundingClientRect();
      const offset = rect.top + rect.height / 2 - viewport / 2;
      // Never move further than the extra image height, so no edge shows.
      const limit = Math.max(0, (el.offsetHeight - rect.height) / 2);
      const shift = Math.max(-limit, Math.min(limit, offset * -Number(el.dataset.mjParallax)));
      el.style.transform = `translate3d(0, ${shift.toFixed(1)}px, 0)`;
    });
  };

  const requestUpdate = () => {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => (entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target)));
    requestUpdate();
  });

  const init = () => {
    document.querySelectorAll('[data-mj-parallax]').forEach((el) => observer.observe(el));
    requestUpdate();
  };

  window.addEventListener('scroll', requestUpdate, { passive: true });
  window.addEventListener('resize', requestUpdate);
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
